import { useEffect } from "react";
const useAutoSendFromUrl = ({
  isActivelyStreaming,
  conversationLength,
  onSearch
}) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const query = params.get("query");
    params.get("stacklineSku");
    if (query && !isActivelyStreaming && conversationLength === 0) {
      onSearch(query);
      params.delete("query");
      params.delete("stacklineSku");
      const newUrl = params.toString() ? `${window.location.pathname}?${params.toString()}` : window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }
  }, [isActivelyStreaming, conversationLength]);
};
export {
  useAutoSendFromUrl
};
//# sourceMappingURL=useAutoSendFromUrl.js.map
